<template>
    <div class="container container-vertical container-vertical-centered" style="width:80%; padding: 4rem 0;">

        <h2>{{ titulo }}</h2>
        <br>

        <component :is="currentComponent" v-bind="componentProps"></component>

    </div>

</template>

<script>
    import BemVindo from './BemVindo.vue';
    import DadosCadastrais from './DadosCadastrais.vue';
    import Questionario from './Questionario.vue';
    import Resultado from './Resultado.vue';

    import axios from 'axios';

    export default {
        name: 'MainComponent',
        components: {
            BemVindo,
            DadosCadastrais,
            Questionario,
            Resultado,
        },
        data() {
            return {
                currentComponent: 'BemVindo',
                dadosCadastrais: null,
                questionario: null,
                questoes: null,
                resultado: null,
                respostas: null,
                contatoSaved: null,
                titulo: 'Diagnóstico Gerencial Resumido',
            }
        },
        computed: {
            componentProps () {
                if (this.currentComponent === 'Questionario') {
                    return { questoes: this.questoes };
                }

                if (this.currentComponent === 'Resultado') {
                    return {
                      resultado: this.resultado,
                      contato: this.contatoSaved
                    };
                }
            }
        },
        methods: {
            showBemVindo() {
                this.currentComponent = 'BemVindo';
            },
            showDadosCadastrais () {
                this.scrollTop();
                this.currentComponent = 'DadosCadastrais';
            },
            showQuestionarios (dadosCadastrais) {
                this.scrollTop();
                this.dadosCadastrais = dadosCadastrais;
                this.currentComponent = 'Questionario';
            },
            showResultado (count, respostas) {
                this.scrollTop();
                this.resultado = count;
                this.respostas = respostas;
                this.titulo = 'Processando...';
                this.currentComponent = '';
                this.saveQuestionarioRespostas();
            },
            scrollTop () {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            },
            saveQuestionarioRespostas() {
              /*console.log(JSON.stringify({
                contato: this.dadosCadastrais,
                respostas: this.respostas,
                resultado: this.resultado
              }));*/
              
              /*axios.post('/api/questionarioestatico', {
                contato: this.dadosCadastrais,
                respostas: this.respostas,
                resultado: this.resultado
              }).then(response => {
                console.log(response);
                this.contatoSaved = response.data.contato;
                this.currentComponent = 'Resultado';
              }).catch(error => {
                console.log(error.message);
              })*/

              axios.post('/questionariodiagnostico', {
                contato: this.dadosCadastrais,
                respostas: this.respostas,
                resultado: this.resultado
              }).then(response => {
                console.log(response);
                //this.contatoSaved = response.data.contato;
                //this.isSaving = false;
                this.titulo = 'Resultado';
                this.currentComponent = 'Resultado';
              }).catch(error => {
                console.log(error.message);
              })
              /*
              this.currentComponent = 'Resultado';
              */
            }
        },
        mounted () {
            axios.get('./js/questoes.json')
            .then(response => {
                this.questoes = response.data;
            })
            .catch(error => {
                console.log(error);
            });
        }
    }
</script>

<style>
.side-menu {
    margin-left: 20px;
}

.main-card {
    margin: 0 20px;
}

@media only screen and (max-width: 600px) {
    .side-menu {
        margin: 0 20px;
        margin-bottom: 20px;
    }

    .main-card {
        padding-bottom: 20px;
    }
}

.centered{
    margin: 0 auto;
}
</style>
